/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class SuscripcionesClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getGroups = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'notif/group' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  getApplications = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'notif/applications' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  addApplications = async (data) => {
    try {
      const response = await this.request('post')(
        { data },
        { path: 'notif/subscriptions/groups' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  addSubscriptionsAll = async (data) => {
    try {
      const response = await this.request('post')(
        { data },
        { path: 'notif/subscriptions/groups/all' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  deleteApplications = async (data) => {
    try {
      const response = await this.request('delete')(
        { data },
        { path: 'notif/subscriptions/groups' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  deleteSubscriptionsAll = async (data) => {
    try {
      const response = await this.request('delete')(
        { data },
        { path: 'notif/subscriptions/groups/all' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  getCanales = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'notif/subscriptions/canales' },
      );
      return response;
    } catch (error) {
      console.log('error ==== ', error);
      return error.response;
    }
  }

  getCanalesPreferencias = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'notif/subscriptions/canales/preferencias' },
      );
      return response.data.collection_preferencias.preferencias;
    } catch (error) {
      return error.response;
    }
  }

  putCanalesPreferencias = async (data) => {
    try {
      const response = await this.request('put')(
        { data },
        { path: 'notif/subscriptions/canales/preferencias' },
      );
      return response;
    } catch (error) {
      return error.response;
    }
  }

  getTiposNegocio = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'notif/subscriptions/canales/canalesfijos' },
      );
      const parse = response.data && response.data[0] ? response.data[0].valor.split(',') : [];
      return parse;
    } catch (error) {
      return error.response;
    }
  }
}
